<template>
  <div>
    <q-table
      dense
      :data="usuarios"
      :columns="columns"
      :grid="$q.screen.xs"
      :pagination="initialPagination"
      :filter="textFilter"
    >
      <template v-slot:top-left >
        <q-input dense filled v-model="textFilter" label="Filtrar" />
      </template>
      <template v-slot:top-right >
        <q-btn icon="add" label="novo" color="primary" dense flat @click="onClickNovo" />
      </template>
      <template v-slot:body-cell-habilitado="props">
        <q-td :props="props">
          <div>
            <q-badge :color="renderColorHabilitado(props.row.habilitado).color">
              <q-icon :name="renderColorHabilitado(props.row.habilitado).value" />
            </q-badge>
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-nivel="props">
        <q-td :props="props">
          <div>
            <q-badge :color="renderColorNivel(props.row.nivel).color" :label="renderColorNivel(props.row.nivel).value" />
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-editar="props">
        <q-td :props="props">
          <q-btn 
            color="primary"
            icon="edit"
            rounded
            size="xs"
            @click="selectUsuario(props.row)"
          >
            <q-tooltip>Editar</q-tooltip>
          </q-btn>
          <q-btn 
            color="warning"
            icon="mail"
            rounded
            size="xs"
            @click="resetPassword(props.row)"
          >
            <q-tooltip>Resetar senha do usuário</q-tooltip>
          </q-btn>
        </q-td>
      </template>
      <template v-slot:item="props">
        <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition">
          <q-card>
            <q-list dense v-for="col in props.cols" :key="col.name">
              <q-item>
                <q-item-section>
                  {{col.label}}
                </q-item-section>
                <q-item-section side>
                  <div v-if="col.name !== 'habilitado' && col.name !== 'editar'">
                    {{col.value}}
                  </div>
                  <div v-if="col.name === 'habilitado'">
                    <q-badge :color="renderColorHabilitado(col.value).color">
                      <q-icon :name="renderColorHabilitado(col.value).value" />
                    </q-badge>
                  </div>
                  <div v-if="col.name === 'editar'">
                    <q-btn 
                      color="primary"
                      icon="edit"
                      rounded
                      size="sm"
                      label="Editar"
                      @click="selectUsuario(props.row)"
                    />
                    <q-btn 
                      color="warning"
                      icon="mail"
                      rounded
                      size="sm"
                      label="Resetar senha"
                      @click="resetPassword(props.row)"
                    />
                  </div>
                </q-item-section>
              </q-item>
            </q-list>
          </q-card>
        </div>
      </template>
    </q-table>
  </div>
</template>

<script>
import { getUsers } from '../../services/usuario'
import { formatCpfCnpj } from '../../filters/cpfCnpj'
import { formatDate } from '../../filters/date'

export default {
  name: 'grid-usuario',
  data () {
    return {
      loading: false,
      textFilter: '',
      initialPagination: {
        page: 1,
        rowsPerPage: 20
      },
      columns: [
        { 
          name: 'criadoEm',
          field: 'criadoEm',
          label: 'Data cadastro',
          align: 'left',
          format: value => formatDate(value),
          sortable: true
        },
        { name: 'nome', field: 'nome', label: 'Nome', align: 'left' },
        { name: 'cpf', field: 'cpf', label: 'CPF', align: 'left', format: value => formatCpfCnpj(value) },
        { name: 'email', field: 'email', label: 'Email', align: 'left' },
        { name: 'nivel', field: 'nivel', label: 'Nível', align: 'center' },
        { name: 'habilitado', field: 'habilitado', label: 'Habilitado', align: 'center' },
        { name: 'editar', field: 'editar', label: 'Editar', align: 'center' },
      ],
      usuarios: []
    }
  },
  mounted() {
    this.getUsuarios()
  },
  methods: {
    async getUsuarios () {
      try {
        this.loading = true
        const response = await getUsers()
        this.usuarios = response.users.map(x => Object.assign({}, x, { options: '' }))
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    selectUsuario (usuario) {
      this.$emit('on-select', usuario)
    },

    resetPassword (usuario) {
      this.$emit('on-reset-password', usuario)
    },

    onClickNovo () {
      this.$emit('on-click-novo')
    },

    renderColorHabilitado (value) {
      if (value) {
        return {
          color: 'green',
          value: 'check'
        }
      }

      return {
          color: 'red',
          value: 'close'
        }
    },

    renderColorNivel (value) {
      if (value === 'USUARIO') {
        return {
          color: 'info',
          value
        }
      }

      return {
          color: 'positive',
          value
        }
    }
  },
  components: {
  }
}
</script>